<template>
  <div class="page-heading uk-flex uk-flex-middle uk-flex-between">
    <div class="page-heading--title with-left-primary-color-bar">
      <slot>{{ $route.meta.title }}}</slot>
    </div>
    <div class="page-heading--right uk-flex uk-visible@m">
      <span class="uk-flex uk-flex-middle uk-margin-right">
        <span uk-icon="icon: receiver;ratio: 0.8"></span>
        <span>&nbsp;010-67665196</span>
      </span>
      <span class="uk-flex uk-flex-middle">
        <span uk-icon="icon: phone;ratio: 0.8"></span>
        <span>&nbsp;13910962198</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {}
}
</script>

<style lang="scss">
.page-heading {
  padding: 10px 0;
  border-bottom: 3px solid $color-primary;
  margin-bottom: 2.5rem;
  .page-heading--title {
    font-size: 2rem;
    font-weight: 500;
  }
}

@media (max-width: ($screen-width-m - 1)) {
  .page-heading {
    margin-bottom: 1.25rem;
    .page-heading--title {
      font-size: 1.25rem;
    }
  }
}
</style>
